export default "__VITE_ASSET__DW_Yp9rs__"